import {Injectable} from '@angular/core';
import {Resolve} from '@angular/router';
import {Observable, of} from 'rxjs';
import {FacadeService} from '../../service/facade/facade.service';
import {catchError, map} from 'rxjs/operators';
import {Sector} from '../../model/sector/sector.model';

@Injectable()
export class SectorsResolver implements Resolve<Observable<Sector[]>> {
  constructor(private facadeService: FacadeService) {
  }

  resolve(): Observable<Sector[]> {
    return this.facadeService.listSectors().pipe(
      map((data) => data),
      catchError(error => {
        return of({error: error});
      })
    );
  }
}
